import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import documentImg from "../dokument.png";
import { compareAsc, format } from "date-fns";
import LoznicaLogo from "./loznica.jpg";

const styles = StyleSheet.create({
  page: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    padding: 30,
    paddingBottom: 60,
    fontSize: 12,
    fontFamily: 'Helvetica',
    backgroundColor: '#fff',
  },
  
  headerTable: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  
  upperSection: {
    display: "flex",
    flexDirection: "row",
    height: 80,
    border: "1px solid black",
  },
  
  logoCell: {
    width: "20%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  
  logoImg: {
    height: 60,
    width: 60,
  },
  
  upperDataSection: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  
  upperHeaderRow: {
    display: "flex",
    flexDirection: "row",
    height: "50%",
    borderLeft: "1px solid black",
    textAlign: "center"
  },
  
  upperDataRow: {
    display: "flex",
    flexDirection: "row",
    height: "50%",
    borderLeft: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
    alignItems: "center"
  },
  
  titleRow: {
    display: "flex",
    flexDirection: "row",
    height: 40,
    border: "1px solid black",
    borderTop: "none",
    textAlign: "center"
  },
  
  upperCell: {
    width: "25%",
    height: "100%",
    borderRight: "1px solid black",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 3,
    paddingRight: 3,
  },
  
  upperCellLast: {
    width: "25%",
    height: "100%",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 3,
    paddingRight: 3,
  },
  
  lowerCell: {
    width: "25%",
    height: "100%",
    borderRight: "1px solid black",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 3,
    paddingRight: 3,
  },
  
  lowerCellLast: {
    width: "25%",
    height: "100%",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 3,
    paddingRight: 3,
  },
  
  titleCell: {
    width: "100%",
    height: "100%",
    paddingTop: 10,
    paddingBottom: 5,
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: "20px"
  },
  
  upperCellText: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  
  lowerCellText: {
    fontSize: 11,
    textAlign: "center",
  },
  
  titleCellText: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
  },
  
  lowerSection: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid black",
    borderTop: "none",
  },
  
  statsHeaderRow: {
    display: "flex",
    flexDirection: "row",
    height: 45,
  },
  
  statsDataRow: {
    display: "flex",
    flexDirection: "row",
    height: 50,
  },
  
  statsHeaderCell: {
    width: "20%",
    height: "100%",
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 2,
    paddingRight: 2,
  },
  
  statsHeaderCellLast: {
    width: "20%",
    height: "100%",
    borderBottom: "1px solid black",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 2,
    paddingRight: 2,
  },
  
  categoriesDataCell: {
    width: "20%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderRight: "1px solid black",
    padding: 5,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 3,
  },
  
  statsDataCell: {
    width: "20%",
    height: "100%",
    borderRight: "1px solid black",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 3,
    paddingRight: 3,
  },
  
  statsDataCellLast: {
    width: "20%",
    height: "100%",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 3,
    paddingRight: 3,
  },
  
  statsHeaderText: {
    fontSize: 11,
    fontWeight: "bold",
    textAlign: "center",
  },
  
  statsDataText: {
    fontSize: 10,
    textAlign: "center",
  },
  
  categoryBadge: {
    minWidth: 18,
    height: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid black",
    fontSize: 9,
    padding: "3px 6px",
  },
  
  itemList: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    width: "100%",
    marginTop: 15,
  },
  
  itemWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },
  
  itemHeader: {
    height: 80,
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  
  itemNumber: {
    flex: 1,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid gray",
    fontSize: 12,
    fontWeight: "bold",
  },
  
  itemCategories: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid gray",
    borderLeft: "none",
    borderRight: "none",
  },
  
  itemCategoryBadge: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 9,
  },
  
  itemTitle: {
    flex: 9,
    height: "100%",
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    border: "1px solid gray",
    paddingLeft: 8,
    fontSize: 12,
  },
  
  itemInfo: {
    flex: 4,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    border: "1px solid gray",
    borderLeft: "none",
  },
  
  itemInfoRow: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 9,
    textAlign: "center",
    borderBottom: "1px solid gray",
    wordBreak: "break-word",
  },
  
  itemInfoRowLast: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 9,
    textAlign: "center",
  },
  
  itemContent: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },
  
  fieldWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  
  fieldTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#000",
  },
  
  fieldContent: {
    fontSize: 12,
    color: "#000",
    lineHeight: 1.3,
  },
  
  imagesWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: 15,
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  
  itemImage: {
    height: 120,
    maxWidth: "20%",
    objectFit: "contain",
  },
  
  documentsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  
  documentItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    height: 20,
  },
  
  documentIcon: {
    height: 16,
    width: 16,
  },
  
  documentText: {
    fontSize: 12,
  },
  
  linksWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  
  linkText: {
    fontSize: 12,
    color: "#000",
  },
  
  commentsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  
  comment: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    paddingLeft: 25,
  },
  
  commentHeader: {
    display: "flex",
    flexDirection: "row",
    gap: 25,
    alignItems: "center",
    width: "100%",
  },
  
  commentNumber: {
    fontSize: 12,
    fontWeight: "normal",
    width: 25,
  },
  
  commentUser: {
    fontSize: 12,
    width: 100,
  },
  
  commentDate: {
    fontSize: 12,
    width: 80,
  },
  
  commentText: {
    fontSize: 12,
    lineHeight: 1.3,
  },
  
  commentImage: {
    height: 120,
    width: "40%",
    objectFit: "contain",
  },
  
  commentDocument: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    height: 20,
  },
  
  commentSubTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#000",
    marginTop: 5,
  },
  
  commentLink: {
    fontSize: 12,
    color: "#000",
  },
  
  numberOfItem: {
    fontWeight: "bold"
  },

  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 10,
    color: '#666',
  },
  
  pageNumber: {
    fontSize: 10,
    color: '#666',
  },
  
  footerText: {
    fontSize: 10,
    color: '#666',
    textAlign: 'center',
    flex: 1,
  },
});

function Pdf({
  itemList,
  commentsActive,
  linksActive,
  documentsActive,
  imagesActive,
  account,
  location,
  loggedUser,
  numberOfCopy,
  categoriesItem,
}) {
  const handleNumberOfcomment = () => {
    let numberCom = 0;
    itemList.map((item) => {
      if (item.comments.length !== 0) {
        numberCom += item.comments.length;
      }
    });
    return numberCom;
  };

  const getSelectedCategories = () => {
    const selectedCategories = [];
    for (const item of itemList) {
      for (const category of item.categories) {
        if (category.selected && !selectedCategories.find(selectedCategory => selectedCategory.id === category.id)) {
          selectedCategories.push(category);
        }
      }
    }
    return selectedCategories;
  };

  return (
    <Document title={`IZVEŠTAJ - ` + format(new Date(), "dd.MM.yyyy")}>
      <Page size="A4" style={styles.page}>
        {/* Header matching PDFLoader table structure exactly */}
        <View style={styles.headerTable}>
          {/* Upper section with logo and data */}
          <View style={styles.upperSection}>
            {/* Logo section */}
            <View style={styles.logoCell}>
              <Image src={account.logo} style={styles.logoImg} />
            </View>
            
            {/* Right side table */}
            <View style={styles.upperDataSection}>
              {/* Row 1: Headers */}
              <View style={styles.upperHeaderRow}>
                <Text style={styles.upperCell}>KOMPANIJA</Text>
                <Text style={styles.upperCell}>LOKACIJA</Text>
                <Text style={styles.upperCell}>DATUM</Text>
                <Text style={styles.upperCellLast}>PERIOD</Text>
              </View>
              
              {/* Row 2: Data */}
              <View style={styles.upperDataRow}>
                <Text style={styles.lowerCell}>{account?.company_name}</Text>
                <Text style={styles.lowerCell}>{location?.location_name}</Text>
                <Text style={styles.lowerCell}>
                  {itemList.length !== 0 &&
                    format(itemList[0].timeCreated, "dd.MM.yyyy")}
                </Text>
                <Text style={styles.lowerCellLast}>
                  {itemList.length !== 0 &&
                    (compareAsc(
                      new Date(
                        new Date(itemList[0].timeCreated).setHours(0, 0, 0, 0)
                      ),
                      new Date(
                        new Date(
                          itemList[itemList.length - 1].timeCreated
                        ).setHours(0, 0, 0, 0)
                      )
                    ) !== 0
                      ? format(
                          itemList[itemList.length - 1].timeCreated,
                          "dd.MM.yyyy"
                        )
                      : "")}
                </Text>
              </View>
            </View>
          </View>
          
          {/* Title row spanning full width */}
          <View style={styles.titleRow}>
            <Text style={styles.titleCell}>
              IZVEŠTAJ - {format(new Date(), "dd.MM.yyyy")}
            </Text>
          </View>
          
          {/* Lower section - stats spanning full width */}
          <View style={styles.lowerSection}>
            {/* Stats headers */}
            <View style={styles.statsHeaderRow}>
              <View style={styles.statsHeaderCell}>
                <Text style={styles.statsHeaderText}>KATEGORIJE</Text>
              </View>
              <View style={styles.statsHeaderCell}>
                <Text style={styles.statsHeaderText}>BROJ STAVKI I KOMENTARA</Text>
              </View>
              <View style={styles.statsHeaderCell}>
                <Text style={styles.statsHeaderText}>KREATOR</Text>
              </View>
              <View style={styles.statsHeaderCell}>
                <Text style={styles.statsHeaderText}>VREME</Text>
              </View>
              <View style={styles.statsHeaderCellLast}>
                <Text style={styles.statsHeaderText}>BROJ KOPIJE</Text>
              </View>
            </View>
            
            {/* Stats data */}
            <View style={styles.statsDataRow}>
              <View style={styles.categoriesDataCell}>
                {getSelectedCategories().map(category => (
                  <View 
                    key={category.id}
                    style={[
                      styles.categoryBadge,
                      {
                        backgroundColor: category.color,
                        color: category.letter_color,
                      }
                    ]}
                  >
                    <Text style={{ fontSize: 9, color: category.letter_color }}>
                      {category.letter}
                    </Text>
                  </View>
                ))}
              </View>
              <View style={styles.statsDataCell}>
                <Text style={styles.statsDataText}>{itemList.length}</Text>
                <Text style={styles.statsDataText}>{handleNumberOfcomment()}</Text>
              </View>
              <View style={styles.statsDataCell}>
                <Text style={styles.statsDataText}>{loggedUser?.name || loggedUser?.user_email}</Text>
              </View>
              <View style={styles.statsDataCell}>
                <Text style={styles.statsDataText}>{format(new Date(), "HH:mm")}</Text>
              </View>
              <View style={styles.statsDataCellLast}>
                <Text style={styles.statsDataText}>{numberOfCopy !== undefined && numberOfCopy}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Items list */}
        <View style={styles.itemList}>
          {itemList?.map((item, index) => {
            return (
              <View wrap={false} style={styles.itemWrapper} key={item.id}>
                {/* Item header matching PDFLoader exactly */}
                <View style={styles.itemHeader}>
                  <View style={styles.itemNumber}>
                    <Text style={styles.numberOfItem}>{index + 1}.</Text>
                  </View>
                  
                  <View style={styles.itemCategories}>
                    {item.categories?.filter(cat => cat.selected).map((category) => {
                      const height = 100 / item.categories.filter(cat => cat.selected).length;
                      return (
                        <View 
                          key={category.id}
                          style={[
                            styles.itemCategoryBadge,
                            {
                              backgroundColor: category.color,
                              height: `${height}%`,
                            }
                          ]}
                        >
                          <Text style={{ fontSize: 9, color: category.letter_color }}>
                            {category.letter}
                          </Text>
                        </View>
                      );
                    })}
                  </View>
                  
                  <View style={styles.itemTitle}>
                    <Text style={styles.itemTitleText}>{item.title}</Text>
                  </View>
                  
                  <View style={styles.itemInfo}>
                    <View style={styles.itemInfoRow}>
                      <Text style={{ fontSize: 9, wordBreak: "break-word" }}>
                        {((item.name || item.email) || "").length > 25 
                          ? ((item.name || item.email) || "").slice(0, 25) + "..." 
                          : (item.name || item.email) || ""}
                      </Text>
                    </View>
                    <View style={styles.itemInfoRow}>
                      <Text>{format(item.timeCreated, "HH:mm dd.MM.yyyy")}</Text>
                    </View>
                    <View style={styles.itemInfoRowLast}>
                      <Text>{item.comments.length}</Text>
                    </View>
                  </View>
                </View>

                {/* Item content */}
                <View style={styles.itemContent}>
                  {/* Item fields */}
                  {item?.data?.map((field) => {
                    const { id, data, name } = field;
                    return (
                      <View style={styles.fieldWrapper} key={id}>
                        <Text style={styles.fieldTitle}>{name}</Text>
                        <Text style={styles.fieldContent}>{data}</Text>
                      </View>
                    );
                  })}

                  {/* Images */}
                  {imagesActive &&
                    item.images?.length > 0 &&
                    item.images[0]?.data !== "" && (
                      <View style={styles.fieldWrapper}>
                        <Text style={styles.fieldTitle}>Fotografije</Text>
                        <View style={styles.imagesWrapper}>
                          {item.images.map((image, imgIndex) => (
                            <Image
                              key={imgIndex}
                              src={image.data}
                              style={styles.itemImage}
                            />
                          ))}
                        </View>
                      </View>
                    )}

                  {/* Documents */}
                  {documentsActive && item.documents?.length > 0 && (
                    <View style={styles.fieldWrapper}>
                      <Text style={styles.fieldTitle}>Dokumenta</Text>
                      <View style={styles.documentsWrapper}>
                        {item.documents.map((document, docIndex) => (
                          <View key={docIndex} style={styles.documentItem}>
                            <Image src={documentImg} style={styles.documentIcon} />
                            <Text style={styles.documentText}>{document.name}</Text>
                          </View>
                        ))}
                      </View>
                    </View>
                  )}

                  {/* Links */}
                  {linksActive && item.links?.length > 0 && (
                    <View style={styles.fieldWrapper}>
                      <Text style={styles.fieldTitle}>Linkovi</Text>
                      <View style={styles.linksWrapper}>
                        {item.links.map((link) => (
                          <Text key={link.link_id} style={styles.linkText}>
                            {link.link}
                          </Text>
                        ))}
                      </View>
                    </View>
                  )}

                  {/* Comments */}
                  {commentsActive && item.comments?.length > 0 && (
                    <View style={styles.fieldWrapper}>
                      <Text style={styles.fieldTitle}>Komentari</Text>
                      <View style={styles.commentsWrapper}>
                        {item.comments.map((comment, commentIndex) => (
                          <View key={comment.id || commentIndex} style={styles.comment}>
                            <View style={styles.commentHeader}>
                              <Text style={styles.commentNumber}>{commentIndex + 1}.</Text>
                              <Text style={styles.commentUser}>{comment.user}</Text>
                              <Text style={styles.commentDate}>{comment.timeCreated}</Text>
                            </View>
                            
                            {comment.text !== "" && (
                              <Text style={styles.commentText}>{comment.text}</Text>
                            )}
                            
                            {comment.image?.length > 0 && comment.image !== "" && (
                              <View>
                                <Text style={styles.commentSubTitle}>Image</Text>
                                <Image src={comment.image.data} style={styles.commentImage} />
                              </View>
                            )}
                            
                            {comment.document?.length > 0 && (
                              <View>
                                <Text style={styles.commentSubTitle}>Document</Text>
                                <View style={styles.commentDocument}>
                                  <Image src={documentImg} style={styles.documentIcon} />
                                  <Text style={styles.documentText}>{comment.document[0].name}</Text>
                                </View>
                              </View>
                            )}
                            
                            {comment.link !== "" && (
                              <View>
                                <Text style={styles.commentSubTitle}>Link</Text>
                                <Text style={styles.commentLink}>
                                  {comment.link}
                                </Text>
                              </View>
                            )}
                          </View>
                        ))}
                      </View>
                    </View>
                  )}
                </View>
              </View>
            );
          })}
        </View>
        
        <View style={styles.footer} fixed>
          <Text style={styles.footerText}>
            Izveštaj generisan putem aplikacije SARADNIK.APP
          </Text>
          <Text style={styles.pageNumber} render={({ pageNumber }) => `${pageNumber}`} />
        </View>
      </Page>
    </Document>
  );
}

export default Pdf;